(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacerDialogController', RacerDialogController);

    RacerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Racer', 'Trainer', 'Runner', 'Schedule'];

    function RacerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Racer, Trainer, Runner, Schedule) {
        var vm = this;

        vm.racer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.trainers = Trainer.query({filter: 'racer-is-null'});
        $q.all([vm.racer.$promise, vm.trainers.$promise]).then(function() {
            if (!vm.racer.trainer || !vm.racer.trainer.id) {
                return $q.reject();
            }
            return Trainer.get({id : vm.racer.trainer.id}).$promise;
        }).then(function(trainer) {
            vm.trainers.push(trainer);
        });
        vm.runners = Runner.query();
        vm.schedules = Schedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.racer.id !== null) {
                Racer.update(vm.racer, onSaveSuccess, onSaveError);
            } else {
                Racer.save(vm.racer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:racerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.finishDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
